import styled from "styled-components";

export const Wrapper = styled.div`
  .graph-column-container {
    padding-bottom: 10px;
    border-radius: 5px;
  }
  .Pay-history-column-container {
    margin-bottom: 10px;

    h5 {
      font-weight: 500;
      margin: 0px;
    }
  }
  .history-data-Column {
    padding: 2px 15px;
    background: #3a96b8;
    margin-bottom: 5px;
  }

  .collapse-name-header {
    font-size: 17px;
    color: #fff;
  }
  .collapse-amount-header {
    font-size: 15px;
    color: #fff;
  }
  .sub-collapse-row {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .sub-collapse-name {
    padding-left: 11px;
    p {
      margin: 0px;
    }
  }
  /* collapse css below */
  .status-rescheduled-row {
    display: flex;
    align-items: center;
    padding: 0px !important;
    h6 {
      margin: 0px;
    }
  }
  .ant-collapse > .ant-collapse-item > .ant-collapse-header {
    background:linear-gradient(right,#000000,#9be4fe);
    display: flex;
    align-items: center;
  }
  .ant-collapse-expand-icon {
    display: flex;
  }
`;
